import './review.scss';

/**
 * Equalize the height of all review titles within a container
 * @param {HTMLElement} container - The container element containing review titles
 */
function equalizeReviewTitles( container ) {
	const reviewTitles = container.querySelectorAll( '.js-reviewTitle' );
	
	if ( reviewTitles.length === 0 ) {
		return;
	}
	
	// Reset heights to auto to get natural heights
	reviewTitles.forEach( title => {
		title.style.height = 'auto';
	} );
	
	// Calculate the maximum height
	let maxHeight = 0;
	reviewTitles.forEach( title => {
		const height = title.offsetHeight;
		if ( height > maxHeight ) {
			maxHeight = height;
		}
	} );
	
	// Set all titles to the maximum height
	reviewTitles.forEach( title => {
		title.style.height = maxHeight + 'px';
	} );
}

/**
 * Debounce function to limit how often a function can be called
 * @param {Function} func - Function to debounce
 * @param {number} wait - Wait time in milliseconds
 * @returns {Function} Debounced function
 */
function debounce( func, wait ) {
	let timeout;
	return function executedFunction( ...args ) {
		const later = () => {
			clearTimeout( timeout );
			func( ...args );
		};
		clearTimeout( timeout );
		timeout = setTimeout( later, wait );
	};
}

// Export functions for use in other modules
export { equalizeReviewTitles, debounce };

